interface AskChipProps {
  label: string;
  action: string;
  onClick: () => void;
}

/** Caps an accessible name at a sane length. `label` can be an approval's
 *  description — for `dispatch_desktop_task` that's the goal itself, up to
 *  20,000 characters (FRONT-2266) — while the visible chip text is already
 *  clipped by the `truncate` class below; a screen reader has no such cap
 *  and would read the whole string. Ellipsis at the end, no export needed
 *  outside this file's own test. */
export function truncateAccessibleName(text: string, max = 120): string {
  return text.length > max ? `${text.slice(0, max - 1)}…` : text;
}

/**
 * The one thing blocking EDDY, spelled out inline (README §3) — rendered
 * only when at least one chat OR Building Session (FRONT-1681) is `asking`.
 * The design's core bet: counts are ambient, but a block is spelled out in
 * words, so this is never reduced to another dot.
 */
export function AskChip({ label, action, onClick }: AskChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={truncateAccessibleName(`${action}: ${label}`)}
      className="inline-flex h-[38px] max-w-[360px] min-w-0 items-center gap-[8px] overflow-hidden rounded-[11px] border border-amber-500/25 bg-amber-500/10 pr-[12px] pl-[11px] whitespace-nowrap"
    >
      <span className="eddy-tb-blink size-[7px] shrink-0 rounded-full bg-amber-500" />
      <span className="min-w-0 flex-1 truncate text-left text-[13px] text-[var(--ink-0)]">
        {label}
      </span>
      <span className="shrink-0 text-[13px] font-medium text-amber-600 dark:text-amber-400">
        {action}
      </span>
    </button>
  );
}
